/**
 * @file src/shell/i18n/en.js
 * Chuỗi của SHELL, bản tiếng Anh. PHẢI cùng bộ key với vi.js — thiếu key nào thì
 * i18n rơi về tiếng Việt cho key đó, tức UI lẫn hai ngôn ngữ.
 *
 * boot.js chọn từ điển theo ngôn ngữ rồi trộn: { ...SHELL_<LANG>, ...dict của tiết }.
 * Thêm key mới vào vi.js thì thêm luôn ở đây.
 */
export const SHELL_EN = {
  // ----- Bottom bar buttons -----
  // Giữ NGẮN: chữ hiện ngay dưới icon trong ô hẹp. Xem chú thích ở vi.js.
  'btn.rotate': 'Rotate',
  'btn.labels': 'Labels',
  'btn.sound': 'Sound',
  'btn.info': 'Info',
  'btn.settings': 'Settings',

  // ----- Zoom indicator (stepped columns on both sides) -----
  'zoom.label': 'Zoom in / out',

  // ----- Header (top bar) -----
  'header.back': 'Exit',
  'header.pen': 'Pen',
  'header.whiteboard': 'Whiteboard',
  'header.exercise': 'Exercise',

  // ----- Pen layer (free-draw, toggled by the "Pen" button) -----
  'pen.palette': 'Pen colour picker',
  'pen.clear': 'Clear',

  // ----- Whiteboard (toggled by the "Whiteboard" button) -----
  'wb.close': 'Close whiteboard',
  'wb.undo': 'Undo',
  'wb.redo': 'Redo',
  'wb.save': 'Save image',

  // ----- Exercise (ExercisePanel, toggled by the "Exercise" button) -----
  'quiz.close': 'Close exercise',
  'quiz.prev': 'Previous',
  'quiz.next': 'Next',
  'quiz.answer': 'Answer',
  'quiz.progress': 'Question {n}/{total} · {section}',
  'quiz.loading': 'Loading questions…',
  'quiz.empty': 'No exercise for this lesson yet.',
  'quiz.error': 'Could not load questions.',
  'quiz.retry': 'Retry',

  // ----- Info panel -----
  'info.panelTitle': 'Lesson information',
  'info.objectives': 'Learning objectives',

  // ----- Settings -----
  'set.title': 'Settings',
  'set.section.sound': 'Sound',
  'set.section.display': 'Display',
  'set.section.motion': 'Motion',
  'set.sound': 'Sound',
  'set.volume': 'Volume',
  'set.language': 'Language',
  'set.background': 'Background',
  'set.bgDark': 'Black background',
  'set.bgLight': 'Light background',
  'set.bgCustom': 'Pick another colour',
  'set.rotate': 'Rotation',
  'set.reducedMotion': 'Reduce motion',
  'anim.play': 'Play',
  'anim.pause': 'Pause',
  'set.motionSpeed': 'Motion speed',
  'set.on': 'On',
  'set.off': 'Off',
  'lang.vi': 'Tiếng Việt',
  'lang.en': 'English',

  // ----- Loading -----
  'loading.subtitle': 'Loading models and data…',
  'loading.assets': 'Loading assets…',
  'loading.done': 'Done, opening the lesson…',

  // ----- Errors (khớp bộ error code của bridge) -----
  'err.webglUnsupported':
    'Your device or browser does not support 3D graphics yet. You can still read the lesson content below.',
  'err.contextLost': 'Restoring 3D graphics…',
  'err.coreLoadFailed': 'The lesson could not be loaded. Please reload the page.',
  'err.assetFailed': 'One of the lesson assets failed to load.',
  'err.initFailed': 'The lesson could not be opened.',
  'err.runtime': 'Something went wrong in the lesson. Please reload the page.',
  'err.retry': 'Retry',
};
